'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericMobileRow = function GenericMobileRow(_ref) {
  var post = _ref.post;
  return _react2.default.createElement(
    _semanticUiReact.Card.Content,
    null,
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 6, textAlign: 'center', verticalAlign: 'middle' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'picture', size: 'massive', color: 'grey' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 10, textAlign: 'center', verticalAlign: 'middle' },
          _lodash2.default.get(post, 'platform', 'GENERIC'),
          ' ',
          _lodash2.default.get(post, 'assetType', 'ASSET')
        )
      )
    )
  );
};

exports.default = GenericMobileRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/paid-report-row/mobile-components/generic.js
// module id = 2141
// module chunks = 1